import React from 'react';
import TranslationContainer from '../../translation/translation_container';
import { PromotionText } from './promotion_text';

function Value() {
  return (
      <TranslationContainer
          targetProperties={{
            flagText: { translationKey: 'catalog-promotions-promotion-text-flag-text-value' },
            headline: { translationKey: 'catalog-promotions-promotion-text-headline-value' },
            content: { translationKey: 'catalog-promotions-promotion-text-content-value' },
          }}
      >
          <PromotionText
              type="value"
              flagText="will-be-replaced"
              headline="will-be-replaced"
              content="will-be-replaced"
          />
      </TranslationContainer>
  );
}

export { Value };